
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance/contact-us",
      function () {
        return require("private-next-pages/travel-insurance/contact-us/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-insurance/contact-us"])
      });
    }
  